import { render, staticRenderFns } from "./IconBasket.vue?vue&type=template&id=0da7a206&"
import script from "./IconBasket.vue?vue&type=script&lang=js&"
export * from "./IconBasket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports